(function(window, $, localizationStrings) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.iOSTextInputFix = (function() {
      var $window = $(window);
      var _bodyEl = window.document.getElementsByTagName('body')[0];
      var _domEl;
      var _deleteKeyCode = 8;
      var _expectedCharCount = 0;
      var _onBugCallback;
      var _bugExecutionCount = 0;

      var keyUpHandler = function(e) {
         if (e.keyCode === _deleteKeyCode) {
            _expectedCharCount--;
         } else {
            _expectedCharCount++;
         }

         var currentTextValue = _domEl.value;
         var inputDiff = currentTextValue.length - _expectedCharCount;

         // element is no longer getting new keyboard input
         if (inputDiff < 0) {
            var textAreaElClone = _domEl.cloneNode(true);
            _bodyEl.appendChild(textAreaElClone);
            _bugExecutionCount++;

            setTimeout(function() {
               textAreaElClone.focus();
               _bodyEl.removeChild(textAreaElClone);

               if (_onBugCallback) {
                  _onBugCallback(_bugExecutionCount);
               }
            }, 100);

            _expectedCharCount = _domEl.value.length;
         }
      };

      var clear = function() {
         _domEl = undefined;
         $window.unbind('keyup', keyUpHandler);
      };

      return {
         setOnBugCallback: function(callback) {
            _onBugCallback = callback;
         },
         watch: function(domEl) {
            clear();
            _domEl = domEl;
            // issue with search box makes this extra check needed for this temporary iOS fix
            _expectedCharCount = _domEl.value === localizationStrings.strings.search ? 0 : _domEl.value.length;
            $window.bind('keyup', keyUpHandler);
         },
         clear: clear
      };
   })();
})(this, window.jQuery, window.TSC.localizationStrings);
